export default class LowProductionController {
  listOfTabs = [
    { label: 'Tab-1', value: 'tab-1' },
    { label: 'Tab-2', value: 'tab-2' },
    { label: 'Tab-3', value: 'tab-3' },
    { label: 'Tab-4', value: 'tab-4' },
    { label: 'Tab-5', value: 'tab-5' },
  ]
  progressBarIncrement = 1 / (this.listOfTabs.length - 1)
  progressBar = this.progressBarIncrement;
  tabEnd = "tab-4"
  typeOs = 0;

  constructor(typeOs) {
    if (typeOs == '13') {
      typeOs = 13
      this.listOfTabs = [
        { label: 'Tab-1', value: 'tab-1' },
        { label: 'Tab-2', value: 'tab-2' },
        { label: 'Tab-3', value: 'tab-3' },
        { label: 'Tab-5', value: 'tab-5' },
      ]
      this.progressBarIncrement = 1 / (this.listOfTabs.length - 1)
      this.progressBar = this.progressBarIncrement
      this.tabEnd = 'tab-3'
    }
  }

  _changeTab(VALUE_INCREMENT_ID_TAB) {
    if (this.typeOs == 13) {
      tabindex.value += VALUE_INCREMENT_ID_TAB;
      panel.value = STRING_ID_TAB + tabindex.value;
    }
  }
}